import React from 'react';
import './Survey.css';
import Menu from '../../Menu/Menu';
import { Card, CardGroup, Tab, Table, Tabs } from 'react-bootstrap';
import survey from '../../../img/surveyor_device_4.jpg';
import b1 from '../../../img/land2.jpg';
import b2 from '../../../img/topo2.jpg';
import b3 from '../../../img/land3.jpg';
import b4 from '../../../img/B-1.6.png';
import b5 from '../../../img/B-1.7.jpg';
import b6 from '../../../img/B-1.8.jpeg';
import b7 from '../../../img/B-1.9.jpg';
import b8 from '../../../img/B-2.jpg';
import b9 from '../../../img/B-2.png';



const Survey = () => {
    return (
        <div className='mb-5'>
            
            <div className='about6'>
                <div className='bg'>
                    <Menu></Menu>
                    <h1 className='text-white display-5 fw-bold doris pt-lg-5 pb-5 mx-auto top'>Digital Survey</h1>
                </div>
            </div>
            <div id="survey">
                <h2 className='heading pt-5 mx-3'>Digital Survey</h2>
                <hr className='w-50 mx-auto'></hr>
                <h5 className='px-5 mx-lg-3'>
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 pt-3'>
                            <strong>
                                TRUSTED QUALIFIED & EXPERIENCED DISITAL SURVEYORS, ACCURATE
                                DRAWINGS, INCLUDING AutoCAD.
                            </strong><br></br>
                            Digital surveys are typically a first step in any construction or development
                            project, it may be necessary to perform a topographic land survey to identify
                            various features and elevations of area land.<br></br>
                            <strong>PROPER Design & Development Limited</strong> has 5+ years of experience to
                            conducting different type of land surveys with accurate results.<br></br>

                            <strong>Top 3 Benefits of land Survey?</strong><br></br>
                            <ol>
                                <li>
                                    Having a detailed and accurate picture of your land can reduce the risk of
                                    costly downstream mistakes caused by unforeseen issues.
                                </li>
                                <li>
                                    It can provide the necessary data you will need about the land before
                                    making any changes to it.
                                </li>
                            </ol>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12'>
                                <img src={survey} alt="" width="100%" className='mt-5'/>
                            </div>
                            <strong>
                                Different types of digital surveys:
                            </strong><br></br>
                            <Tabs
                                defaultActiveKey="Land Survey"
                                id="justify-tab-example"
                                className=""
                                fill
                                >
                                <Tab eventKey="Land Survey" title="Land">
                                    <div className='sur1 mt-3'>
                                        <div className='bg1'>
                                            <h1 className='text-white display-5 fw-bold doris pb-5 mx-auto top1 text-center'>Land Survey</h1>
                                        </div>
                                    </div>
                                    <div className='row mt-5 mb-3'>
                                        <div className='col-lg-4 col-md-6 col-sm-12 mt-5'>
                                            GPS, Total Station, Theodolite, Leveling based geodetic survey,
                                            Road & canal Alignment survey, Road & canal X-section survey, Land use Plan and digital map preparation.
                                        </div>
                                        <div className='col-lg-8 col-md-6 col-sm-12 d-flex'>
                                            <img src={b1} alt="" width="45%" className='ms-3'/>
                                            <img src={b3} alt="" width="50%"/>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey="Hydrological Survey" title="Hydrological">
                                    <div className='row mb-3'>
                                        <div className='col-lg-8 col-md-6 col-sm-12'>
                                            <div className='sur2 mt-3'>
                                                <div className='bg1'>
                                                    <h1 className='text-white display-5 fw-bold doris pb-5 mx-auto top1 text-center'>Hydrological Survey</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-6 col-sm-12  mt-3 mb-3'>
                                            GPS, DGPS, Echo sounder, etc. based Bathymetric
                                            River X- Section survey, River bank & River bed monitoring, dumping & dredging pre work, monitoring & post work measurement etc. and finally digital map preparation.
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey="BM Position Establish" title="BM Position Establish">
                                    <div className='row mb-3'>
                                        <div className='col-lg-8 col-md-6 col-sm-12'>
                                            <div className='sur3 mt-3'>
                                                <div className='bg1'>
                                                    <h1 className='text-white display-5 fw-bold doris pb-5 mx-auto top1 text-center'>BM Position Establish</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-6 col-sm-12 mt-3 mb-3'>
                                            A "bench mark" associated with surveying can be
                                            referred to a permanent mark created at a recognized height which is used as the basis for measuring different altitude of topographical point. To survey different land in a area there BM is standard point.
                                        </div>
                                    </div>
                                
                                </Tab>
                                <Tab eventKey="Topographic digital survey" title="Topographic digital">
                                    <div className='sur4 mt-3'>
                                            <div className='bg1'>
                                                <h1 className='text-white display-5 fw-bold doris pb-5 mx-auto top1 text-center'>Topographic digital survey</h1>
                                            </div>
                                        </div>
                                    <div className='row mt-5 mb-3'>
                                        <div className='col-lg-7 col-md-6 col-sm-12'>
                                            <img src={b2} alt="" width="100%"/>
                                        </div>
                                        <div className='col-lg-5 col-md-6 col-sm-12 mt-3 mb-3'>
                                            A topographic survey locates all surface
                                            features of a property, and depicts all natural features and elevations. In essence it is a 3-dimensional map of a 3-dimensional property showing all
                                            natural and man-made features and improvements. Specifically, it shows their
                                            location, size, height and any changes in elevation. Topographical
                                            surveys are typically needed by architects and engineering corporations
                                            once the land is being developed or altered. This include like new buildings,
                                            and land repurposing.
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey="Cadastral (Mouza) Digital Survey" title="Cadastral (Mouza) Digital">
                                    <div className='row mb-3'>
                                        <div className='col-lg-8 col-md-6 col-sm-12'>
                                            <div className='sur5 mt-3'>
                                                <div className='bg1'>
                                                    <h1 className='text-white display-5 fw-bold doris pb-5 mx-auto top1 text-center'>Cadastral (Mouza) Digital Survey</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-6 col-sm-12 mt-3 mb-3'>
                                            Cadastral surveying is the sub-field
                                            of cadaster and surveying that specializes in the establishment and reestablishment of real property boundaries. It involves the physical depiction of
                                            property boundaries and determination of dimensions, areas and certain
                                            rights associated with properties.
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey="Contour Survey" title="Contour">
                                    <div className='row mb-3'>
                                        <div className='col-lg-8 col-md-6 col-sm-12'>
                                            <div className='sur6 mt-3'>
                                                <div className='bg1'>
                                                    <h1 className='text-white display-5 fw-bold doris pb-5 mx-auto top1 text-center'>Contour Survey</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-6 col-sm-12 mt-3 mb-3'>
                                            The process of tracing contour lines on the surface of the
                                            earth is called contouring and the maps upon which these lines are drawn are called contour maps.
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey="Drone Survey" title="Drone">
                                    <div className='row mb-3'>
                                        <div className='col-lg-8 col-md-6 col-sm-12'>
                                            <div className='sur7 mt-3'>
                                                <div className='bg1'>
                                                    <h1 className='text-white display-5 fw-bold doris pb-5 mx-auto top1 text-center'>Drone Survey</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-6 col-sm-12 mt-3 mb-3'>
                                            Drone Surveying is one of the leading providers of surveying
                                            services to the construction sector in the development country. we are
                                            conducts different type of drone photograph, drone 4k videos in different
                                            festivals, and survey where needed.
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey="Layout Survey" title="Layout">
                                    <div className='row mb-3'>
                                        <div className='col-lg-8 col-md-6 col-sm-12'>
                                            <div className='sur8 mt-3'>
                                                <div className='bg1'>
                                                    <h1 className='text-white display-5 fw-bold doris pb-5 mx-auto top1 text-center'>Layout Survey</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-6 col-sm-12 mt-3 mb-3'>
                                        we also conducts different type layout plan. layout survey
                                means the measurements made to control elevation, horizontal position and
                                dimensions, and configuration, prior to or while construction is in progress.
                                        </div>
                                    </div>
                                
                                </Tab>
                                <Tab eventKey="Setting out Survey" title="Setting out">
                                    <div className='row mb-3'>
                                        <div className='col-lg-8 col-md-6 col-sm-12'>
                                            <div className='sur9 mt-3'>
                                                <div className='bg1'>
                                                    <h1 className='text-white display-5 fw-bold doris pb-5 mx-auto top1 text-center'>Setting out Survey</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-6 col-sm-12 mt-3 mb-3'>
                                        A set-out survey is used to set out the exact position of a
                                proposed structure within the legal boundaries of a piece of land. This kind of
                                survey is very important when preparing for any type of construction work.
                                        </div>
                                    </div>
                                
                                </Tab>
                                <Tab eventKey="As-build Survey" title="As-build">
                                <div className='row mb-3'>
                                        <div className='col-lg-8 col-md-6 col-sm-12'>
                                            <div className='sur10 mt-3'>
                                                <div className='bg1'>
                                                    <h1 className='text-white display-5 fw-bold doris pb-5 mx-auto top1 text-center'>As-build Survey</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-6 col-sm-12 mt-3'>
                                        An as built survey is a precise measurement of the
                                inside and outside of your building. To serve as a record of the land-use
                                history as-built survey is needed. The as-built becomes a document of
                                what once existed. To serve as a reference and a certified record of
                                what was built. This means the document is useful as a reference for
                                future improvement, even after the construction has been completed.
                                        </div>
                                    </div>
                                
                                </Tab>
                                <Tab eventKey="Road Survey" title="Road">
                                    <div className='row mb-3'>
                                        <div className='col-lg-8 col-md-6 col-sm-12'>
                                            <div className='sur11 mt-3'>
                                                <div className='bg1'>
                                                    <h1 className='text-white display-5 fw-bold doris pb-5 mx-auto top1 text-center'>Road Survey</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-6 col-sm-12 mt-3 mb-3'>
                                        For making Correct road alignment Road survey is very important eighter
                                rigid or flexible pavement. To determine the “right of way” Survey is very
                                important. We are already done 50 plus road survey in Bangladesh.
                                        </div>
                                    </div>
                                
                                </Tab>
                            </Tabs>
                            
                        
                            {/* <div className='d-flex mt-3'>
                                <img src={b1} alt="" width="50%" className='me-2'/>
                                <img src={b2} alt="" width="50%" className='me-2'/>
                            </div>
                            <div className='d-flex justify-content-between mt-3'>
                                <h5 className='heading'>Land Survey</h5>
                                <h5 className='heading'>Topographic digital survey</h5>
                                
                            </div> */}
                        
                        
                    </div>
                    <div>

                        {/* <div className='row'>
                            <div className='col-lg-6 col-md-6 col-sm-12 pt-3'>
                                
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 pt-3'>
                                <div className='d-flex mt-3'>
                                    <img src={b3} alt="" width="50%" className='me-2'/>
                                    <img src={b5} alt="" width="50%" className='me-2'/>
                                </div>
                                <div className='d-flex justify-content-between mt-3'>
                                    <h5 className='heading'>Contour Survey</h5>
                                    <h5 className='heading'>Drone Survey</h5>
                                </div>
                                <div className='d-flex mt-3'>
                                    <img src={b6} alt="" width="50%" className='me-2'/>
                                    <img src={b7} alt="" width="50%" className='me-2'/>
                                </div>
                                <div className='d-flex justify-content-between mt-3'>
                                    <h5 className='heading'>Layout Survey</h5>
                                    <h5 className='heading'>Setting out Survey</h5>
                                </div>
                            </div>
                        </div> */}
                        
        
                                
                    </div>
                </h5>
            </div>   
        </div>
    );
};

export default Survey;